import { render } from "./NewMessageTypingIndicator.vue?vue&type=template&id=3a685bfa&scoped=true"
import script from "./NewMessageTypingIndicator.vue?vue&type=script&lang=js"
export * from "./NewMessageTypingIndicator.vue?vue&type=script&lang=js"

import "./NewMessageTypingIndicator.vue?vue&type=style&index=0&id=3a685bfa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a685bfa"]])

export default __exports__